import React, { useContext, useEffect, useState } from "react";
import expandIcon from "../../../../assets/icons/ExpandIcon.svg";
import courseIcon from "../../../../assets/icons/RecentCourseIcon.svg";
import AuthContext from "../../../../auth/AuthContext";
import AlertService from "../../../../services/AlertService";
import CourseService from "../../../../services/CourseService";
import { Skeleton } from "primereact/skeleton";

const LearnerRecentCourseCard = () => {
  const authContext = useContext(AuthContext);
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(false);

useEffect(() => {
    const controller = new AbortController(); 

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await CourseService.GetRecentDashboard(
          authContext,
          controller.signal 
        );

        if (controller.signal.aborted) return; 

        if (!response) return;
        if (response.isSuccess) {
          setCourse(response.data);
        } else {
          AlertService.error(response.errorMessage);
        }
      } catch (err) {
        if (err.name === "AbortError") return; 
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    fetchData();

    return () => controller.abort();
  }, [authContext]);

  if (loading) {
    return (
      <div
        className="card charts rounded-3"
        style={{ width: "100%", minHeight: "357px" }}
      >
        <div className="card-body p-3 d-flex flex-column justify-content-between h-100">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <Skeleton width="150px" height="20px" />
            <Skeleton shape="circle" size="26px" />
          </div>
          <div className="d-flex align-items-start gap-2 mb-2">
            <Skeleton shape="circle" size="45px" />
            <div>
              <Skeleton width="200px" height="18px" />
              <Skeleton width="150px" height="14px" className="mt-2" />
            </div>
          </div>
          <Skeleton width="100%" height="40px" className="mb-3" />
          <div className="d-flex justify-content-between small mb-3">
            <Skeleton width="120px" height="16px" />
            <Skeleton width="120px" height="16px" />
          </div>
        </div>
      </div>
    );
  }

  return (
    course && (
      <div
        className="card charts rounded-3"
        style={{ width: "100%", minHeight: "357px" }}
      >
        <div className="card-body p-3 d-flex flex-column justify-content-between h-100">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">Recently Enrolled Courses</h6>
            <a href="#courses" className="text-decoration-none">
              <img
                src={expandIcon}
                alt="open"
                style={{ width: "26px", height: "26px" }}
              />
            </a>
          </div>
          <div className="d-flex align-items-start gap-2">
            <img
              src={courseIcon}
              alt="course"
              style={{ width: "52px", height: "45px" }}
            />
            <div>
              <h6 className="link mb-1" style={{ lineHeight: "1.4" }}>
                {course.courseName}
              </h6>
            </div>
          </div>
          <p className="small mb-3 mt-0" style={{ lineHeight: "1.4" }}>
            {course.description}
          </p>
          <div className="w-100" style={{ borderBottom: "2px dotted #ccc" }}></div>
          <div className="d-flex justify-content-between small mb-3">
            <span className="text-muted">
              Start Date:{" "}
              <span className="text-primary">{course.plannedStartDate}</span>
            </span>
            <span className="text-muted">
              End Date:{" "}
              <span className="text-primary">{course.plannedEndDate}</span>
            </span>
          </div>
        </div>
      </div>
    )
  );
};

export default LearnerRecentCourseCard;
